/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Status_ClosedInputs */

const en_admin_tickets_status_closed = /** @type {(inputs: Admin_Tickets_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Admin_Tickets_Status_ClosedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_tickets_status_closed = /** @type {((inputs?: Admin_Tickets_Status_ClosedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Status_ClosedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_tickets_status_closed(inputs)
});
export { admin_tickets_status_closed as "admin.tickets.status_closed" }